// Dependenceis
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import getClassNames from 'classnames';
import { FontIcon, FlatButton, CircularProgress, IconButton } from 'material-ui';
import RaisedButton from '../tc-ui/raised-button-with-loader';
import ProfileImage from '../app-bar/profile-image';
import docCookies from '../../utils/docCookie';
const ColoredAccomImg = require('../../../www/images/accommodation-with-color.svg');
const ColoredNonAccomImg = require('../../../www/images/non-accommodation-with-color.svg');
import LockIcon from 'material-ui/svg-icons/action/lock';
import {
  either,
  isNil,
  isEmpty,
  not,
  pathOr,
  prop,
  contains,
  call,
  ifElse,
  equals,
  always,
} from 'ramda';
// import { getMarketingMaterials } from '../../stores/partner-finder/partnerFinder-actions';
// import Filmstrip from '../tc-ui/filmstrip/container';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import logoGlobeSrc from '../../../www/images/tourconnect-logo-globe.svg';
import WallWrapper from '../wall/wrapper';

// Components
import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];

const isNilOrEmpty = either(isNil, isEmpty);

class ListItem extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     showMM: false,
  //     loadingMM: false,
  //   };
  // }
  //
  // getMM = () => {
  //   const { dispatch, companyId, locationId } = this.props;
  //   this.setState({ loadingMM: true });
  //   dispatch(getMarketingMaterials(companyId, locationId))
  //   .then(() => this.setState({ loadingMM: false }));
  // }

  transitionToProfile = () => {
    const { companyId, router } = this.props;
    const routeName = `/company/${companyId}`;
    router.push({
      pathname: routeName,
      state: {
        from: 'PF',
        text: 'Back To Results',
      },
    });
  };

  transitionToLocation = () => {
    const { locationId, router } = this.props;
    const routeName = `/locations/${locationId}`;
    // docCookies.setItem('fromPF', true);
    router.push({
      pathname: routeName,
      state: {
        from: 'PF',
        text: 'Back To Results',
      },
    });
  };

  acceptConnection = () => {
    this.props.acceptConnection(this.props.connectionId);
  };

  ignoreConnection = () => {
    this.props.ignoreConnection(this.props.connectionId);
  };

  sendInvitation = () => {
    const companyId = this.props.companyId;
    this.props.sendInvitation(companyId);
  };

  resendConnection = () => {
    this.props.resendConnection(this.props.connectionId);
  };

  fakeResendConnection = () => {
    this.props.fakeResendInvitation(this.props.connectionId);
  };

  render() {
    const {
      partnerFinder,
      city,
      state,
      numOfAcceptedConn,
      numCompletedProds,
      numOfMM,
      locationId,
      locationName,
    } = this.props;

    const id = this.props.companyId;
    const classes = getClassNames('connections-company-name', this.props.className, {
      'is-link': id,
    });

    const listItemClasses = getClassNames('connections-list-item', {
      'is-open': this.state,
    });

    const createBadge = (icon, iconColor, tooltip) => {
      return (
        <IconButton
          iconClassName={icon}
          style={{ padding: '0', width: '13px', marginLeft: '2px' }}
          iconStyle={{ fontSize: '14px', color: iconColor }}
          tooltip={tooltip}
          tooltipPosition="bottom-right"
        />
      );
    };

    const companyNameForHeader = (companyNameLarger, showIcon) => {
      return (
        <div
          style={{
            marginBottom:
              this.props.industryVerified ||
              this.props.tourConnectVerified ||
              this.props.hasMM ||
              this.props.quickResponder ||
              this.props.ratesLoaded
                ? '-15px'
                : '',
          }}
        >
          <div
            className="connections-list-header"
            onClick={locationId ? this.transitionToLocation : this.transitionToProfile}
            style={{ fontSize: companyNameLarger ? '14px' : '' }}
          >
            {showIcon ? (
              <img
                src={ColoredNonAccomImg}
                height="16px"
                style={{ marginRight: '5px', cursor: 'default' }}
              />
            ) : (
              <span />
            )}
            <span style={{ fontSize: companyNameLarger ? '14px' : '' }}>
              {this.props.companyName}
            </span>
          </div>
          <span style={{ marginLeft: '-13px' }}>
            {this.props.tourConnectVerified
              ? (
                <IconButton
                  style={{ padding: '0', width: '13px', marginLeft: '2px' }}
                  tooltip="TourConnect Verified"
                  tooltipPosition="bottom-right"
                >
                  <img src={logoGlobeSrc}/>
                </IconButton>
            ) : ''}
            {this.props.industryVerified
              ? createBadge('tc-icon-verified_user', '#97E397', 'Industry Verified')
              : ''}
            {this.props.hasMM
              ? createBadge(
                  'tc-icon-photo',
                  '#0080ff',
                  `${numOfMM} ${numOfMM === 1 ? 'Marketing Material' : 'Marketing Materials'}`,
                )
              : ''}
            {this.props.quickResponder
              ? createBadge('tc-icon-update', '#7F00FF', 'Usually Responds Within 7 Days')
              : ''}
            {locationName && this.props.ratesLoaded
              ? createBadge('tc-icon-description', '#ff7f00', 'Rates Loaded')
              : ''}
          </span>
        </div>
      );
    };

    const header = (() => {
      // for suppliers
      if (locationName) {
        return (
          <div>
            {this.props.businessTypes ? (
              <div>
                {companyNameForHeader(false, true)}
                <div
                  className="connections-list-header"
                  style={{ display: 'block', fontSize: '14px' }}
                  onClick={this.transitionToLocation}
                >
                  {locationName}
                </div>
              </div>
            ) : (
              <div>
                <div
                  className="connections-list-header"
                  style={{ display: 'block', color: '#00bcd4' }}
                  onClick={this.transitionToLocation}
                >
                  <img
                    src={ColoredAccomImg}
                    height="16px"
                    style={{ marginRight: '5px', cursor: 'default' }}
                  />
                  {locationName}
                </div>
                {companyNameForHeader(true)}
              </div>
            )}
          </div>
        );
      }
      // for contractors
      return companyNameForHeader(false);
    })();
    let companyTypes;
    if (this.props.businessTypes) {
      const businessTypes = this.props.businessTypes;
      if (!businessTypes[0]) businessTypes.shift();
      companyTypes = businessTypes.join(', ');
    }

    const companyDisplay = (
      <div className={classes} style={{ overflow: 'visible' }}>
        <div className="inner-tags-container">{header}</div>
        <small>
          {(() => {
            if (city && state) return `${city}, ${state}`;
            if (city) return city;
            return state;
          })()}
        </small>
        <br />
        <small>{companyTypes}</small>
      </div>
    );

    const styles = {
      buttonDiv: { width: '200px', display: 'inline-block', textAlign: 'center' },
      upgradeButtonDiv: {
        width: '31%',
        display: 'inline-block',
        textAlign: 'center',
        marginRight: '2%',
      },
      button: { width: '100%' },
      leftButton: { width: '47.5%', display: 'inline-block', minWidth: '47.5%' },
      rightButton: { display: 'inline-block', marginLeft: '5%', width: '47.5%', minWidth: '47.5%' },
      labelStyle: { fontSize: '12px', padding: '0 6px' },
    };
    const connectButton = (() => {
      if (this.props.status !== 'unconnected') {
        if (this.props.status === 'accepted') {
          return (
            <div style={styles.buttonDiv}>
              <FontIcon style={{ marginRight: '5px', marginTop: '5px', marginLeft: '-10px' }}>
                <CheckIcon color="#00bcd4" />
              </FontIcon>
              <div
                style={{
                  verticalAlign: 'top',
                  lineHeight: '34px',
                  display: 'inline-block',
                  color: '#00bcd4',
                }}
              >
                Partners
              </div>
            </div>
          );
        } else if (this.props.status === 'pending') {
          if (this.props.isSender) {
            const daysToRespond = pathOr(
              0,
              [0, 'daysToRespond'],
              (partnerFinder.responseTime || []).filter(item => item.companyId === id),
            );
            return (
              <div style={styles.buttonDiv}>
                {not(isNilOrEmpty(prop('responseTime', partnerFinder))) &&
                contains(
                  id,
                  (partnerFinder.responseTime || []).map(item => item.companyId),
                ) &&
                daysToRespond !== -1 ? (
                  <RaisedButton
                    style={styles.button}
                    loader={this.props.loader}
                    onClick={this.resendConnection}
                    secondary
                    label={
                      daysToRespond > 30
                        ? 'Avg response: > 30 days'
                        : `Avg Response: ${daysToRespond < 1 ? '< 1 day' : `${daysToRespond} days`}`
                    }
                    labelStyle={{ fontSize: '12px', whiteSpace: 'pre' }}
                  />
                ) : (
                  <RaisedButton
                    style={styles.button}
                    loader={this.props.loader}
                    onClick={this.resendConnection}
                    secondary
                    label={languageSettings.partnerFinder.rightContent.resend}
                  />
                )}
                <div style={{ display: 'block', fontSize: '10px' }}>
                  {languageSettings.partnerFinder.rightContent.lastSent + this.props.lastSent}
                </div>
              </div>
            );
          }
          if (this.props.loader)
            return (
              <div style={styles.buttonDiv}>
                <RaisedButton style={styles.button} loader />
              </div>
            );
          return (
            <div style={styles.buttonDiv}>
              <FlatButton
                style={styles.rightButton}
                primary
                labelStyle={{ padding: '0' }}
                onTouchTap={this.ignoreConnection}
                label="Reject"
              />
              <FlatButton
                style={styles.leftButton}
                labelStyle={{ color: 'green', padding: '0' }}
                onTouchTap={this.acceptConnection}
                label="Accept"
              />
            </div>
          );
        } else if (this.props.status === 'rejected') {
          if (this.props.isSender) {
            return (
              <div style={styles.buttonDiv}>
                <RaisedButton
                  style={styles.button}
                  loader={this.props.loader}
                  onClick={this.fakeResendConnection}
                  secondary
                  label={languageSettings.partnerFinder.rightContent.resend}
                />
                <div style={{ display: 'block', fontSize: '10px' }}>
                  {languageSettings.partnerFinder.rightContent.lastSent + this.props.lastSent}
                </div>
              </div>
            );
          }
          return (
            <div style={styles.buttonDiv}>
              <FlatButton
                style={styles.button}
                disabled
                label={languageSettings.partnerFinder.rightContent.ignored}
              />
            </div>
          );
        }
      } else {
        const daysToRespond = pathOr(
          0,
          [0, 'daysToRespond'],
          (partnerFinder.responseTime || []).filter(item => item.companyId === id),
        );
        return (
          <div style={styles.buttonDiv}>
            {not(isNilOrEmpty(prop('responseTime', partnerFinder))) &&
            contains(
              id,
              (partnerFinder.responseTime || []).map(item => item.companyId),
            ) &&
            daysToRespond !== -1 ? (
              <RaisedButton
                style={styles.button}
                loader={this.props.loader}
                onClick={this.resendConnection}
                secondary
                label={
                  daysToRespond > 30
                    ? 'Avg response: > 30 days'
                    : `Avg Response: ${daysToRespond < 1 ? '< 1 day' : `${daysToRespond} days`}`
                }
                labelStyle={{ fontSize: '12px', whiteSpace: 'pre' }}
              />
            ) : (
              <RaisedButton
                id={`connectbutton${this.props.companyId}`}
                loader={this.props.loader}
                style={styles.button}
                onClick={() =>
                  this.props.openPopover({
                    popOverAnchorEl: `connectbutton${this.props.companyId}`,
                    receiverInfo: {
                      companyId: this.props.companyId,
                      companyName: this.props.companyName,
                    },
                  })
                }
                primary
                label="Send Partner Request"
              />
            )}
          </div>
        );
      }
    })();

    // const findPhotosForComp = locationId ?
    //   pathOr([], [0, 'media'], (partnerFinder.connectionsWithMM || []).filter(connection => connection.locationId === locationId))
    //   : pathOr([], [0, 'media'], (partnerFinder.connectionsWithMM || []).filter(connection => connection.companyId === id));

    // const generateThumbnails = (photos) => {
    //   return (
    //     <div style={{ height: '50px', overflow: 'hidden', marginBottom: '5px' }}>
    //       {
    //         (photos || []).map((url, i) => <img key={i} src={url} height="50px" style={{ borderRadius: '7px', marginRight: '5px' }}/>)
    //       }
    //     </div>
    //   );
    // };

    // const MMFilmstrip = () => {
    //   return (
    //     <div style={{ margin: '15px 0 0 1.5%', clear: 'both', borderBottom: '1px solid #e0e0e0', width: '95%' }}>
    //       {
    //         call(ifElse(
    //           equals(true),
    //             () => call(ifElse(
    //               equals(true),
    //                 () => (<div style={{ marginBottom: '5px' }}>
    //                   <Filmstrip
    //                     photos={findPhotosForComp}
    //                   />
    //                 </div>),
    //               () => generateThumbnails(findPhotosForComp)
    //             ), findPhotosForComp.length > 14),
    //           () => always(<span/>)
    //         ), contains(id, partnerFinder.connectionsWithMM.map(item => item.companyId)))
    //       }
    //       {
    //         this.state.loadingMM ?
    //           <div style={{ textAlign: 'center' }}>
    //             <CircularProgress />
    //           </div> : <span/>
    //       }
    //     </div>
    //   );
    // };

    const numOfConnections = () => {
      return (
        <div
          style={{
            minHeight: !locationName ? '80px' : '',
            textAlign: 'center',
            paddingTop: !locationName
              ? companyTypes && companyTypes.length > 83
                ? '20px'
                : '15px'
              : '-5px',
          }}
        >
          <b>{numOfAcceptedConn}</b>
          <br />
          <span style={{ fontSize: '10px' }}>
            {numOfAcceptedConn === 1 ? 'Connection' : 'Connections'}
          </span>
        </div>
      );
    };

    return (
      <div className={listItemClasses}>
        <div
          className="connections-profile-image-container"
          style={{
            minHeight: !locationName ? '80px' : '',
            marginTop: !locationName
              ? companyTypes && companyTypes.length > 83
                ? '20px'
                : '10px'
              : '20px',
          }}
        >
          <ProfileImage
            className="profile-link-image connections-profile-link-image"
            companySlugName={this.props.companyName}
            imageUrl={this.props.profileImageUrl}
          />
        </div>
        <div style={{ marginLeft: '48px', borderBottom: '1px solid #e0e0e0' }}>
          <div
            style={{
              padding: '16px 0px',
              display: 'inline-block',
              float: 'left',
              width: '64px',
              marginLeft: '30px',
            }}
          >
            {numOfConnections()}
            {locationName && numCompletedProds ? (
              <div
                style={{
                  textAlign: 'center',
                  borderTop: '1px solid #e0e0e0',
                  marginTop: companyTypes ? '15px' : '5px',
                }}
              >
                <div
                  style={{
                    margin: companyTypes && !locationName ? '15px 0 -15px 0' : '5px 0 -5px 0',
                  }}
                >
                  <b>{numCompletedProds}</b>
                  <br />
                  <span style={{ fontSize: '10px' }}>
                    {numCompletedProds === 1 ? 'Product' : 'Products'}
                  </span>
                </div>
              </div>
            ) : (
              <span />
            )}
          </div>
          <div className="connections-company-container">
            {companyDisplay}
            {connectButton}
          </div>
        </div>
      </div>
    );
  }
}

ListItem.propTypes = {
  isForPremiumUser: PropTypes.bool,
  companyId: PropTypes.string,
  locationId: PropTypes.string,
  connectionId: PropTypes.string,
  className: PropTypes.string,
  locationName: PropTypes.string,
  history: PropTypes.object,
  companyName: PropTypes.string,
  status: PropTypes.string,
  industryVerified: PropTypes.number,
  tourConnectVerified: PropTypes.number,
  lastSent: PropTypes.string,
  profileImageUrl: PropTypes.string,
  isSender: PropTypes.bool,
  loader: PropTypes.bool,
  businessTypes: PropTypes.array,
  router: PropTypes.object,
  openUpgrade: PropTypes.func,
  acceptConnection: PropTypes.func,
  ignoreConnection: PropTypes.func,
  sendInvitation: PropTypes.func,
  resendConnection: PropTypes.func,
  fakeResendInvitation: PropTypes.func,
  user: PropTypes.object,
  openPopover: PropTypes.func,
  hasMM: PropTypes.number,
  dispatch: PropTypes.func,
  partnerFinder: PropTypes.object,
  city: PropTypes.string,
  state: PropTypes.string,
  numOfAcceptedConn: PropTypes.number,
  numCompletedProds: PropTypes.number,
  numOfMM: PropTypes.number,
  quickResponder: PropTypes.number,
  ratesLoaded: PropTypes.number,
};

const mapStateToProps = ({ partnerFinder }) => ({
  partnerFinder: partnerFinder.toJS(),
});

export default connect(mapStateToProps)(ListItem);



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/list-item-partnerFinder.jsx